"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const SwitchIndicator = _ref => {
  let {
    left,
    width
  } = _ref;
  const nodeStyle = _react.default.useMemo(() => ({
    left: `${left}px`,
    width: `${width}px`
  }), [left, width]);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "switch-indicator",
    style: nodeStyle
  });
};
SwitchIndicator.displayName = 'SwitchIndicator';
process.env.NODE_ENV !== "production" ? SwitchIndicator.propTypes = {} : void 0;
SwitchIndicator.defaultProps = {};
var _default = exports.default = SwitchIndicator;